import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Platform } from 'react-native';

// Import translations
import en from '../../locales/en.json';
import es from '../../locales/es.json';
import fr from '../../locales/fr.json';
import de from '../../locales/de.json';

// Language resources
const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
};

// Supported languages
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', nativeName: 'English' },
  { code: 'es', label: 'Spanish', nativeName: 'Español' },
  { code: 'fr', label: 'French', nativeName: 'Français' },
  { code: 'de', label: 'German', nativeName: 'Deutsch' },
];

// Default language
export const DEFAULT_LANGUAGE = 'en';

// i18n configuration
const initI18n = async () => {
  await i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: DEFAULT_LANGUAGE, // Default language
      fallbackLng: DEFAULT_LANGUAGE, // Fallback language if translation is missing
      debug: false, // Enable manually for debugging

      // Interpolation options
      interpolation: {
        escapeValue: false, // React already escapes values
      },

      // React options
      react: {
        useSuspense: false, // Disable suspense for React Native compatibility
        bindI18n: 'languageChanged loaded', // Re-render on language change
        bindI18nStore: 'added removed',
      },

      // Compatibility options
      compatibilityJSON: 'v3', // Use i18next v3 JSON format

      // Cache settings
      cache: {
        enabled: true,
      },

      // Key separator
      keySeparator: '.', // Allow nested keys like 'common.welcome'

      // Namespace separator
      nsSeparator: ':', // Allow namespaces like 'common:welcome'

      // Load options
      load: 'currentOnly', // Only load current language, not all variations

      // Preload languages for fast switching
      preload: ['en', 'es', 'fr', 'de'],
    });

  console.log('[i18n] Initialized with language:', i18n.language);
  console.log('[i18n] Available languages:', Object.keys(resources));
  return i18n;
};

// Initialize immediately
initI18n();

export default i18n;
export { initI18n };